module.exports = __webpack_public_path__ + "static/media/Trash.01f7dfb5.svg";